/**
* contact scroll animation
*/

const contactScroll = () => {
  const contact = document.querySelector(".contact-sticky");
  
  if(!contact) return;
  window.addEventListener("scroll", () => {
    if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100) {
      contact.classList.add("js-contact-scroll");
    }
    else {
      contact.classList.remove("js-contact-scroll");
    }
  })
}
  
  export default contactScroll